import { ELEMENTS, type Element } from './constants'

/**
 * **다섯 기운 수 · 가장 많은 것 · 가장 적은 것 — 한 곳**.
 *
 * 예전에는 같은 셈이 여섯 곳에 따로 있었고(teaser·manual·nameReading·report/fallback·study/basis …), 동점이면 모두
 * 목·화·토·금·수 순서의 첫 기운 **하나만** 골랐다. 그래서 AI 재료에 "흙=물" 동점이 "가장 많은 것: 흙" 으로만 갔고,
 * 글이 "흙이 제일 많다" 고 썼다.
 *
 *   most / least   같은 수를 나눠 가진 기운 **모두** (목·화·토·금·수 순서)
 *   strongest / weakest   그 가운데 첫 기운 — 하나만 필요한 자리(부적의 채울 기운·캐시 열쇠·별명 소리)가 쓴다.
 *                         예전 값과 같다 (동점이면 순서상 첫 기운).
 */
export interface ElementBalance {
  counts: Record<Element, number>
  most: Element[]
  least: Element[]
  strongest: Element
  weakest: Element
  /** 가장 많은 것·가장 적은 것에 동점이 있는가 */
  tied: boolean
}

type CountsInput = Record<Element, number> | readonly { element: Element; count: number }[]

export function elementBalance(input: CountsInput): ElementBalance {
  const counts = Object.fromEntries(ELEMENTS.map((e) => [e, 0])) as Record<Element, number>
  if (Array.isArray(input)) for (const { element, count } of input as readonly { element: Element; count: number }[]) counts[element] = count
  else for (const e of ELEMENTS) counts[e] = (input as Record<Element, number>)[e] ?? 0
  const max = Math.max(...ELEMENTS.map((e) => counts[e]))
  const min = Math.min(...ELEMENTS.map((e) => counts[e]))
  const most = ELEMENTS.filter((e) => counts[e] === max)
  const least = ELEMENTS.filter((e) => counts[e] === min)
  return { counts, most, least, strongest: most[0]!, weakest: least[0]!, tied: most.length > 1 || least.length > 1 }
}

